module.exports = __webpack_public_path__ + "img/IEC13939.0aca1949.svg";